export default "__VITE_ASSET__DeFkLuVI__"